export const nav = {
  product: "Program",
  roadmap: "Roadmap",
  customers: "Affiliate",
  pricing: "Offer",
  contact: "Contact",
  tryKlark: "Join us",
  menu: "Menu"
};

export const hero = {
  earlyAdopter: "Affiliate Program",
  headline: "What if your network allowed you to",
  headlineAccent: "improve your incomes and your business?",
  subheadline: "Let's build Klark together through our affiliate program. Whether you're an entrepreneur, a professional, or simply convinced by our solution, this program is for you.",
  joinEarlyAdopters: "Apply",
  watchDemo: "Watch Demo",
  aiActive: "Beta-test",
  revenueGrowth: "Revenue Growth"
};

export const pricing = {
  title: "Limited offer",
  subtitle: "Share this exclusive price with your network, along with unlimited access to all AI features. Standard rates will apply after the public launch.",
  toggleMonthly: "Monthly",
  toggleAnnual: "Annual",
  savingsBadge: "Save 55%",
  monthlyLabel: "MONTHLY",
  annualLabel: "ANNUAL",
  monthlyPrice: "€49.99",
  annualPrice: "€23.25",
  perMonthHT: "/ month excl. VAT",
  monthlyBilled: "Billed monthly, no commitment",
  annualBilled: "€279 billed annually",
  freeTrial: "7-day free trial",
  earlyAccess: "Early access — Exclusive offer",
  twoMonthsFree: "2 months free included in the subscription",
  features: {
    bankAggregation: "Aggregation of all your bank accounts",
    crm: "Cross-channel customer CRM",
    tools: "Access to all tools (Fakture, Kalendar, Dokument...)",
    integrations: "Shopify, Stripe, PayPal, PrestaShop integrations",
    partnerDiscounts: "Access to partner discounts",
    prioritySupport: "Priority support",
    updates: "Updates included"
  },
  promote: "Promote it",
  endsIn: "Early Access ends in:",
  timeUnits: {
    days: "days",
    hours: "hours",
    minutes: "minutes",
    seconds: "seconds"
  },
  secureSpot: "Promote it",
  savings: "Save €320 annually • Cancel anytime"
};

export const features = {
  title: "How to present simply",
  titleAccent: "What is Klark?",
  subtitle: "Find all the features here that evolve based on customer feedback.",
  items: [
    {
      title: "Deep learning",
      description: "Klark AI trains on your company data, exclusively for your company."
    },
    {
      title: "Financial indicators",
      description: "Sync your business bank accounts and analyze your cash flow instantly."
    },
    {
      title: "All your data in one place",
      description: "Sync your stores, products and customers and manage everything from Klark."
    },
    {
      title: "AI-enhanced tools: limitless productivity",
      description: "Devis, Fakture, MeetPlanner, Showkase, Digital Safe, Kaisse, Reminders, Kalkulator..."
    },
    {
      title: "Strategic Partnerships",
      description: "Take advantage of negotiated rates with numerous high-quality partners."
    },
    {
      title: "Klark Network",
      description: "Connect with the right people 24/7 on Discord and during Klark physical events."
    },
    {
      title: "A 360° view of your business",
      description: "Centralize, analyze, modify, and plan with ease from Klark."
    },
    {
      title: "AI Co-Founder",
      description: "Your AI ally that thinks, learns, and grows at the same pace as your business.  Exceed your own limits."
    }
  ],
  betaAccess: "Coming soon"
};

export const perks = {
  title: "Your network will save up to",
  titleAccent: "$2 500 000 on their tools",
  subtitle: "Klark gives them access to exclusive benefits negotiated with over 500 software packages/SaaS providers, among the best on the market.",
  askAccess: "Promote it",
  brands: [
    "6 months free on the Business plan with Unlimited AI",
    "Waived Stripe fees on the next $20,000 in payment processing",
    "25% off annual plans.",
    "25% off new plan purchases",
    "90% off for 1 year",
    "14 days free + 33% off annual plans."
  ]
};

export const roadmap = {
  title: "Klark roadmap",
  titleAccent: "next steps",
  subtitle: "By joining the Klark community, you will participate in the development of future improvements.",
  items: [
    {
      quarter: "Q4 2025",
      title: "AI Implementation",
      description: "Benefit from AI added to all your Klark tools."
    },
    {
      quarter: "Q1 2026",
      title: "Klark AI Iterations",
      description: "Rollout of the beta version of your AI co-founder Klark."
    },
    {
      quarter: "Q2 2026",
      title: "MCP Server Implementation + Beta Testers Program",
      description: "Discover Klark Neural. Bring your projects to life, your business can now think."
    },
    {
      quarter: "Q3 2026",
      title: "Commercialization & Product Improvement",
      description: "Commercial deployment of Klark in EU and USA, improvement of existing tools."
    }
  ]
};

export const affiliation = {
  primaryTitle: "Turn your network into",
  titleAccent: "incomes",
  subtitle: "Join our affiliate program and start generating your first income",
  youCanEarn: "Earn up to",
  perMonth: "per month",
  description: "Based on Klark offer of €49/month with 25% commission",
  referrals: "Referrals",
  firstBoxTitle: "25% Commission",
  firstBoxDesc: "For life, for each referral*",
  secondBoxTitle: "30-Days",
  secondBoxDesc: "Commission paid after this period",
  thirdBoxTitle: "Affiliate Dashboard",
  thirdBoxDesc: "Coming soon",
  affiliateButton: "Join The Program",
  footnote: "* Commission paid subject to the effective payment of the subscription by the referral.",
  firstStepTitle: "Apply",
  firstStepDesc: "Your application will be reviewed before approval",
  secondStepTitle: "Share",
  secondStepDesc: "Share your unique link with your audience",
  thirdStepTitle: "Earn",
  thirdStepDesc: "Up to 25% commission thanks to your conversions",
};

export const testimonials = {
  title: "Who can join our",
  titleAccent: "affiliate program?",
  subtitle: "Like many companies, join the Klark community of entrepreneurs",
  items: [
    {
      name: "Content creators",
      role: "YouTubers, Infopreneurs, Instagram, TikTok LinkedIn, Telegram...",
      quote: "Share your personalized referral code with your audience and maximize your earnings",
      metrics: ""
    },
    {
      name: "Media",
      role: "Bloggers, Editors, Freelance Journalists, Web Agencies...",
      quote: "Recommend Klark to your readers with your personalized code and monetize your influence.",
      metrics: ""
    },
    {
      name: "Training & Support",
      role: "Incubators, Training Centers, Business Schools, Accelerators",
      quote: "Recommend Klark to the entrepreneurs you support and earn recurring commissions.",
      metrics: ""
    }
  ]
};

export const contact = {
  title: "Get in",
  titleAccent: "touch",
  subtitle: "Have questions about Klark? We'd love to hear from you. Send us a message and we'll respond within 24 hours.",
  form: {
    name: "Name",
    email: "Email",
    company: "Company",
    subject: "Subject",
    message: "Message",
    namePlaceholder: "Your full name",
    emailPlaceholder: "your.email@company.com",
    companyPlaceholder: "Your company name",
    subjectPlaceholder: "What can we help you with?",
    messagePlaceholder: "Tell us more about your needs and how we can help...",
    maxChars: "Maximum 500 characters",
    sendMessage: "Send Message",
    required: "*"
  },
  success: "Message sent successfully!",
  error: "Failed to send message. Please try again."
};

export const finalCta = {
  title: "Ready to boost",
  titleAccent: "your income?",
  subtitle: "Join the Affiliate Program and share your personalized code widely.",
  getKlark: "Introduce Klark to others",
  learnMore: "Learn More",
  guarantees: ["30-day guarantee", "No setup fees", "Cancel anytime"]
};

export const footer = {
  description: "Klark: The AI cockpit revolutionizing how entrepreneurs build, run, and scale.",
  sections: {
    product: {
      title: "Product",
      links: ["Features", "Roadmap", "API", "Security"]
    },
    company: {
      title: "Company",
      links: ["About", "Blog", "Careers", "Contact"]
    },
    support: {
      title: "Support",
      links: ["Help", "Privacy", "Terms", "Legal"]
    }
  },
  copyright: "© 2025 Klark. All rights reserved.",
  poweredBy: "Made with ❤️"
};

export default {
  nav,
  affiliation,
  hero,
  pricing,
  features,
  perks,
  roadmap,
  testimonials,
  contact,
  finalCta,
  footer
};
